/**
 * 팩 아키텍처 승격(2026-08-14) 이후 이 파일은 이사 팩으로 가는 호환 레이어다.
 * 새 코드는 `./packs/registry`의 `getPack(packId)`를 쓴다.
 * 정본은 `src/domain/packs/`이며 `docs/08-content-data.md`(이사)와
 * `docs/08-content-data-cleaning.md`(청소)가 콘텐츠 원본이다.
 */
import { movingPack } from './packs/moving';
import { emptyResultsFor } from './packs/types';

export { certaintyValues, packIds, emptyResultsFor, validatePack } from './packs/types';
export type { Certainty, PackId, PackContract, PackAnchor, AnchorForce, ChecklistItem, ItemResult } from './packs/types';

/** 이사 팩 체크리스트. 팩을 명시하지 않은 기존 호출부의 기본값이다. */
export const checklist = movingPack.checklist;

export const emptyResults = () => emptyResultsFor(movingPack);
